import React, { useContext, useEffect, useState } from "react";
import {
    Label,
    Wrapper,
    SingleValueWrapper,
    OptionWrapper,
} from "./styled.js";
import SelectAsync from 'react-select/lib/Async';
import { AppContext } from "hocs/withAppContext";
import { fetchAssets } from "./service";

const SingleValue = ({ innerProps, innerRef, data }) =>
    <SingleValueWrapper ref={innerRef} {...innerProps}>
        {data.Name}
    </SingleValueWrapper>;

const Option = ({ innerProps, innerRef, data }) =>
    <OptionWrapper ref={innerRef} {...innerProps}>
        <p>{data.Name}</p>
        {data.objectLocation && <p>{data.objectLocation.stringName}</p>}
    </OptionWrapper>;

export const SelectAsset = ({ label, placeholder, required,
                                value = '', onChange, error,
                                disabled, location }) => {
    const { role } = useContext(AppContext);
    const roleId = role.objectId;

    const [defaultOptions, setDefaultOptions] = useState([]);
    useEffect(() => {
        fetchAssets(roleId, '', location).then(setDefaultOptions);
    }, [roleId, location]);

    return <Wrapper key={location} className="select-box">
        {label && <Label required={required}>{label}</Label>}
        <SelectAsync
            className={ error ? 'data-error': ''}
            classNamePrefix="react-select"
            placeholder={placeholder}
            required={required}
            defaultOptions={defaultOptions}
            loadOptions={q => fetchAssets(roleId, q, location)}
            components={{ SingleValue, Option }}
            isClearable={true}
            value={value}
            onChange={onChange}
            isDisabled={disabled}
        />
    </Wrapper>
};

export default SelectAsset;
